export default __webpack_public_path__ + "static/media/logo-lg-1024w.b064e4ea.webp";